import { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import styles from "./BlogList.module.scss";
import { NavLink, useSearchParams } from "react-router-dom";
import ScreenLoader from "../../../elements/CustomScreeenLoader/ScreenLoader";
import DOMPurify from "../../../utils/DomPurifier";
import { fetchBlogList } from "../../../helpers/common";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [screenLoader, setScreenLoader] = useState(true);
  const [queryParams, setQueryParams] = useSearchParams();
  const currentPage = Number(queryParams.get("page")) || 1;
  const blogsPerPage = 6;

  const loadBlogs = async () => {
    const list = await fetchBlogList();
    setBlogs(list || []);
    if (list) setScreenLoader(false);
  };

  useEffect(() => {
    loadBlogs();
  }, []);

  const goToPage = (page) => {
    queryParams.set("page", page);
    setQueryParams(queryParams);
  };

  const totalPages = Math.ceil(blogs?.length / blogsPerPage);
  const startIndex = (currentPage - 1) * blogsPerPage;
  const currentPageBlogs = blogs?.slice(startIndex, startIndex + blogsPerPage);

  if (screenLoader) {
    return <ScreenLoader />;
  }

  return (
    <>
      <Grid container spacing={3} className={styles.blogListContainer}>
        {currentPageBlogs.map((blog, index) => (
          <Grid
            key={index}
            size={{
              xs: 12,
              sm: 6,
              md: 4
            }}>
            <NavLink to={`/blogs/${blog.slug}#blog-details`}>
              <Box className={styles.blogItem}>
                <Box
                  className={styles.image}
                  sx={{ backgroundImage: `url(${blog.cover_image})` }}
                />
                <Box className={styles.content}>
                  <Typography variant="caption" className={styles.subtitle}>
                    {blog.title}
                  </Typography>
                </Box>
                <Box className={styles.description}>
                  <Typography variant="body2">
                    <div
                      className={styles["col-data"]}
                      style={{ whiteSpace: "pre-line" }}
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(blog?.description),
                      }}
                    ></div>
                  </Typography>
                </Box>
              </Box>
            </NavLink>
          </Grid>
        ))}
      </Grid>
      {blogs?.length > blogsPerPage && (
        <Box className={styles.paginationWrapper}>
          <button
            className={styles.pageBtn}
            disabled={currentPage === 1}
            onClick={() => goToPage(currentPage - 1)}
          >
            ← Prev
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter((page) => {
              return (
                page === 1 ||
                page === totalPages ||
                (page >= currentPage - 1 && page <= currentPage + 1)
              );
            })
            .map((page, index, arr) => {
              if (index > 0 && page - arr[index - 1] > 1) {
                return (
                  <span key={`ellipsis-${page}`} className="px-2">
                    ...
                  </span>
                );
              }
              return (
                <button
                  className={styles.pageBtn}
                  onClick={() => goToPage(index + 1)}
                  disabled={page === currentPage}
                >
                  {page}
                </button>
              );
            })}

          <button
            className={styles.pageBtn}
            disabled={currentPage === totalPages}
            onClick={() => goToPage(currentPage + 1)}
          >
            Next →
          </button>
        </Box>
      )}
    </>
  );
};

export default BlogList;
